import constants from "utils/constants";

import { loadSupportContact } from "api/contacts";

import { AppThunk } from "store/store";
import {
    setErrorResponseMessage,
    setLoaderVisibility,
} from "store/common/initialization/initialization-actions";
import { setSupportContact } from "store/contacts/contacts-actions";

export const fetchSupportContact = (): AppThunk => async (dispatch) => {
    dispatch(setLoaderVisibility(true));
    dispatch(setErrorResponseMessage(""));

    const [payload, status] = await loadSupportContact();

    if (payload && status === constants.statusCode.OK) {
        dispatch(setSupportContact(payload));
    }

    dispatch(setLoaderVisibility(false));
};
